import { render, staticRenderFns } from "./ModalEditLimiteCnpj.vue?vue&type=template&id=6b64125e&scoped=true&lang=true&"
import script from "./ModalEditLimiteCnpj.vue?vue&type=script&lang=js&"
export * from "./ModalEditLimiteCnpj.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditLimiteCnpj.vue?vue&type=style&index=0&id=6b64125e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64125e",
  null
  
)

export default component.exports